var _circle, _rect, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUprLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#1967D2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 33,
    width: 49,
    height: 40,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 24.8503V33.5H56.5V24.4528C56.5 22.5301 55.9137 20.6531 54.8192 19.0722C53.0536 16.5218 50.1491 15 47.0472 15H45.3503C42.2921 15 39.4073 16.4205 37.5427 18.8445C36.2182 20.5664 35.5 22.6779 35.5 24.8503Z",
    stroke: "white",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 52.5,
    r: 4.5,
    fill: "#1967D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUprLock);
export default __webpack_public_path__ + "static/media/UPR_Lock.29be9958bf76c8e0470d31a72e2aea46.svg";
export { ForwardRef as ReactComponent };